import * as React from 'react'

const InfoFilled = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.25 16.75H10a.75.75 0 100 1.5h4a.75.75 0 100-1.5h-1.25V9.5a.75.75 0 00-.75-.75h-2a.75.75 0 000 1.5h1.25v6.5zm.75 5c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75zM12 7.5a1 1 0 100-2 1 1 0 000 2z" />
  </svg>
)

export default InfoFilled
